
// Libraries
var React = require('react');
var sneakpeek = require('sneakpeek');

// Styles
require('./MainNavigationBar.scss');

// Assets
var logoImg = require('images/logo-new.svg');
var poppyLogo = require('images/poppy.png');
var menuIcon = require('./menu_icon.svg');

class MainNavigationBar extends React.Component {

	componentDidMount() {
		sneakpeek(this.navBar);

		if (typeof window === "undefined") return;

		if (window.location.hash) {

			this.navBar.classList.add('sneakpeek--hidden');

		}
	}

	render() {
		const env = this.props.env;

		let poppy;

		if (this.props.showLogoPoppy) {
			poppy = <img src={poppyLogo} className={"MainNavigationBar__logo__holiday"} alt="" />;
		}

		return (
			<div id="main-nav" className={"MainNavigationBar" + (this.props.showLogoPoppy ? " poppy" : "")} ref={(navBar) => { this.navBar = navBar; }}>
				<div className={"MainNavigationBar__content"}>
					<div className={"MainNavigationBar__logo"}>
						<a href="/">
							{poppy}
							<img src={logoImg} alt="Navigate to home" />
						</a>
					</div>
					<div className={"MainNavigationBar__icon" + (env ? " env" : "")}>
						<button className="js-nav-open-button" ref={this.props.openRef} onClick={this.props.toggleMenu} onKeyDown={this.props.focusHandler} aria-label="Open main navigation">
							<img src={menuIcon} alt=""></img>
							<span>MENU</span>
						</button>
					</div>
					{env &&
						<p className="MainNavigationBar__beta">{env}</p>
					}
				</div>
			</div>
		)
	}
}

module.exports = MainNavigationBar;



// WEBPACK FOOTER //
// ./src/components/Navigation/MainNavigation/MainNavigationBar.js